import { RowProps } from 'antd/lib/grid/row';
import { ColProps } from 'antd/lib/col';

export const defaultHorizontalGutter = { xs: 16, sm: 24, md: 24, lg: 40 };

export const rowDefaultProps: RowProps = { gutter: [defaultHorizontalGutter, 20] };
export const rowTextBlockProps: RowProps = { gutter: [defaultHorizontalGutter, 0] };
export const rowHorizontalDefaultProps: RowProps = { gutter: [defaultHorizontalGutter, 0] };
export const rowThumbnailProps: RowProps = { gutter: [defaultHorizontalGutter, 40] };
export const rowReferenceGridProps: RowProps = { gutter: [defaultHorizontalGutter, 0] };
export const rowInformativeGridProps: RowProps = { gutter: [defaultHorizontalGutter, 20] };
export const rowMagazineBrochuresProps: RowProps = { gutter: [defaultHorizontalGutter, 40] };

export const colSmallCardProps: ColProps = { xs: { span: 12 }, md: { span: 8 }, lg: { span: 8 } };
export const colMediumCardProps: ColProps = { xs: { span: 24 }, md: { span: 8 }, lg: { span: 8 } };
export const colLargeCardProps: ColProps = {
  xs: { span: 24 },
  sm: { span: 12 },
  md: { span: 12 },
  lg: { span: 12 },
};
export const colMagazineBrochuresProps: ColProps = {
  xs: { span: 24 },
  sm: { span: 12 },
  md: { span: 8 },
  lg: { span: 8 },
};
export const colOverviewProps: ColProps = { xs: { span: 12 }, md: { span: 8 }, lg: { span: 12 } };
export const colTextComponentProps: ColProps = { xs: { span: 24 }, sm: { span: 12, offset: 6 } };
export const colTitleSublineProps: ColProps = {
  xs: { span: 24 },
  sm: { span: 24 },
  md: { span: 12 },
};

export const colInstagramCardPropsHomePage = {
  xs: { span: 12 },
  sm: { span: 12 },
  md: { span: 6 },
  lg: { span: 6 },
};

export const colInstagramCardPropsMagazinePage = {
  xs: { span: 12 },
  sm: { span: 12 },
  md: { span: 8 },
  lg: { span: 8 },
};
